export default "__VITE_ASSET__BUjmRo_N__"